import { SVGProps, Ref, forwardRef } from 'react';

export const TinkoffIdSolidSize24Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={37} height={24} viewBox="0 0 37 24" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <path
            d="M29.309 12.214c0-1.044-.575-1.66-1.953-1.66h-1.23v3.358h1.23c1.38 0 1.953-.735 1.953-1.698"
            fill="currentColor"
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M9.998 2h17.004C32.524 2 37 6.477 37 12s-4.476 10-9.998 10H9.998C4.476 22 0 17.523 0 12S4.476 2 9.998 2m6.574 5.141H5.8v5.419c0 1.388.74 2.672 1.944 3.367l3.442 1.988 3.442-1.988a3.89 3.89 0 0 0 1.944-3.367zm6.149 8.256V9.03h-2.008v6.367zm8.635-3.183c0 1.832-1.257 3.183-3.797 3.183h-3.37V9.03h3.584c2.325 0 3.583 1.352 3.583 3.184"
            fill="currentColor"
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M8.756 9.993v1.685c.23-.261.649-.437 1.128-.437h.52v1.96c0 .521-.141.977-.352 1.228h2.264c-.209-.251-.35-.707-.35-1.227v-1.96h.52c.479 0 .898.177 1.128.438V9.995h-4.86z"
            fill="currentColor"
        />
    </svg>
));
TinkoffIdSolidSize24Glyph.displayName = 'TinkoffIdSolidSize24Glyph';
